const t = "https://d1asgbu35ychbr.cloudfront.net", o = "https://d3syewzhvzylbl.cloudfront.net";
export {
  t as S3_BUCKET_URL,
  o as S3_SHARED_BUCKET_URL
};
